import BaseModel from 'src/model/base.model';
import ListItem from './listItem.model';

class ListModel extends BaseModel {
  public listNumber: number = 0;
  public favorite: boolean = false;
  public name: string = '';
  public listItems?: {
    [key: string]: ListItem;
  };
}

export default ListModel;
